import Axios from "axios";
import ApiUtils from "../utils/api_utils";
const BaseUrl = `https://${ApiUtils.authority}`;

const AnnouncementSM = {
  state: {
    announcementList: [],
    announcementDetail: {},
    dataLikes: {},
  },
  reducers: {
    setAnnouncementState(state, payload) {
      return {
        ...state,
        ...payload,
      };
    },
  },
  effects: (dispatch) => ({
    async getAnnouncementList(payload, rootState) {
      let result;
      await Axios.get(
        `${BaseUrl}/feeds/api/list/?type=announcement&pagination=false`,
        {
          headers: ApiUtils.getHeader({ token: rootState.LoginSM.token }),
          withCredentials: false,
        }
      )
        .then(function (response) {
          dispatch.AnnouncementSM.setAnnouncementState({
            ...rootState.AnnouncementSM,
            announcementList: response.data,
          });
          result = {
            status: 200,
            data: response.data,
            message: "success",
          };
        })
        .catch(function (error) {
          result = {
            status: 400,
            message: error.response.data,
          };
        });

      return result;
    },

    async getAnnouncementDetail(id, rootState) {
      let result;
      await Axios.get(`${BaseUrl}/events/api/announcements/${id}/`, {
        headers: ApiUtils.getHeader({ token: rootState.LoginSM.token }),
        withCredentials: false,
      })
        .then(function (response) {
          dispatch.AnnouncementSM.setAnnouncementState({
            ...rootState.AnnouncementSM,
            announcementDetail: response.data,
          });
          result = {
            data: response.data,
            status: 200,
            message: "success",
          };
        })
        .catch(function (error) {
          result = {
            status: 400,
            message: error.response.data,
          };
        });

      return result;
    },

    async getListLikes(id, rootState) {
      let result;
      await Axios.get(`${BaseUrl}/events/api/announcement/${id}/likes/`, {
        headers: ApiUtils.getHeader({ token: rootState.LoginSM.token }),
        withCredentials: false,
      })
        .then(function (response) {
          dispatch.AnnouncementSM.setAnnouncementState({
            ...rootState.AnnouncementSM,
            dataLikes: response.data,
          });
          result = {
            data: response.data,
            status: 200,
            message: "success",
          };
        })
        .catch(function (error) {
          result = {
            status: 400,
            message: error.response.data,
          };
        });

      return result;
    },

    async postLikeDetail(id, rootState) {
      let result;
      await Axios({
        method: "post",
        url: `${BaseUrl}/events/api/announcement/${id}/likes/`,
        headers: ApiUtils.getHeader({ token: rootState.LoginSM.token }),
        withCredentials: false,
      })
        .then(function (response) {
          result = {
            data: response.data,
            status: 200,
            message: "success",
          };
        })
        .catch(function (error) {
          result = {
            status: 400,
            message: error.response.data,
          };
        });

      return result;
    },
  }),
};

export default AnnouncementSM;
